import { recordToLang } from '@platform/front-utils';
import startPage from './startPage';

const lang: Record<string, string> = recordToLang(
    {
        productTitle: 'Module for collecting and processing requests',
        startPage,
    },
    false,
);

export default lang;
